export default __webpack_public_path__ + "static/fv-nr-1-f010fe6d1505d35e025a1c8e81ee73db.avif";